import gql from 'graphql-tag'

import { FileProcessFragment } from '@/graphql/fragments/files'

export const query = gql`
  ${FileProcessFragment}
  query fetchFileProcess($id: Int!) {
    records: files_file_process_by_pk(id: $id) {
      ...FileProcess
    }
  }
`

export default query
